import 'aca-design/dist/aca-design.css';
import { BaseZipcode, BaseTaglist, BaseChecklist, BaseSelect, BaseCheckbox, BaseRadio, BaseInput, BaseTextarea, BaseAddress, BasePhoneNumber, BaseProgressBar, BaseFileUpload, BaseMultiSelect, BaseButton, IconCross, IconDone } from 'aca-design';
import ClientOnly from 'vue-client-only';
import loadGoogleMapsApi from 'load-google-maps-api';
import { Loader } from '@googlemaps/js-api-loader';

var script = {
    name: 'FieldInput',

    props: {
        field: {
            type: Object,
            required: true,
        },

        value: {
            type: String,
        },
    },

    data: function data () {
        return {
            focused: false,
            uid: undefined
        }
    },

    mounted: function mounted() {
        var inBrowser = typeof window !== 'undefined';
        if (inBrowser) {
            this.uid = this.field.type + '' + Math.random();
        }
    },

    methods: {
        handleInput: function handleInput($event) {
            this.$emit('valueChange', $event.currentTarget.value);
        },
    },
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    var options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    var hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            var existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-input base-input",class:( _obj = {}, _obj['field-input-' + _vm.field.inputType] = true, _obj['has-value'] =  _vm.value && _vm.value.length, _obj['focused'] =  _vm.focused, _obj )},[_c('label',{attrs:{"for":_vm.uid}},[_c('span',{staticClass:"label-text",domProps:{"innerHTML":_vm._s(_vm.field.label)}})]),_vm._v(" "),_c('div',{staticClass:"input-wrapper"},[_c('input',_vm._g({attrs:{"id":_vm.uid,"placeholder":_vm.field.placeholder,"minlength":_vm.field.minlength,"maxlength":_vm.field.maxlength,"max":_vm.field.max,"min":_vm.field.min,"step":_vm.field.step,"size":_vm.field.size,"spellcheck":_vm.field.spellcheck ? 'true' : 'false',"autocomplete":_vm.field.autocomplete ? _vm.field.autocomplete : 'new-password',"disabled":typeof _vm.field.disabled === 'function' ? _vm.field.disabled() : _vm.field.disabled,"type":_vm.field.inputType},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.handleInput($event, _vm.field)},"focus":function($event){_vm.focused = true;},"blur":function($event){_vm.focused = false;}}},_vm.$listeners))]),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e()])};
var __vue_staticRenderFns__ = [];

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

var script$1 = {
    name: 'FieldTextarea',

    props: {
        field: {
            type: Object,
            required: true,
        },

        value: {
            type: String,
        },
    },

    data: function data () {
        return {
            focused: false,
            uid: undefined
        }
    },

    mounted: function mounted() {
        var inBrowser = typeof window !== 'undefined';
        if (inBrowser) {
            this.uid = this.field.type + '' + Math.random();
        }
    },

    methods: {
        handleInput: function handleInput($event) {
            this.$emit('valueChange', $event.currentTarget.value);
        },
    },
};

/* script */
var __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-textarea base-textarea",class:{ 'has-value': _vm.value && _vm.value.length, 'focused': _vm.focused }},[_c('label',{attrs:{"for":_vm.uid}},[_c('span',{staticClass:"label-text",domProps:{"innerHTML":_vm._s(_vm.field.label)}})]),_vm._v(" "),_c('div',{staticClass:"textarea-wrapper"},[_c('textarea',_vm._g({attrs:{"id":_vm.uid,"placeholder":_vm.field.placeholder,"spellcheck":_vm.field.spellcheck ? 'true' : 'false',"autocomplete":_vm.field.autocomplete ? _vm.field.autocomplete : 'new-password',"disabled":typeof _vm.field.disabled === 'function' ? _vm.field.disabled() : _vm.field.disabled},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.handleInput($event, _vm.field)},"focus":function($event){_vm.focused = true;},"blur":function($event){_vm.focused = false;}}},_vm.$listeners))]),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e()])};
var __vue_staticRenderFns__$1 = [];

  /* style */
  var __vue_inject_styles__$1 = undefined;
  /* scoped */
  var __vue_scope_id__$1 = undefined;
  /* module identifier */
  var __vue_module_identifier__$1 = undefined;
  /* functional template */
  var __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$1 = normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

var script$2 = {
    name: 'FieldCheckbox',

    props: {
        field: {
            type: Object,
            required: true,
        },

        value: {
            type: Boolean,
        },
    },

    data: function data() {
        return {
            uid: undefined
        }
    },

    mounted: function mounted() {
        var inBrowser = typeof window !== 'undefined';
        if (inBrowser) {
            this.uid = this.field.type + '' + Math.random();
        }
    },

    methods: {
        handleChange: function handleChange($event) {
            this.$emit('valueChange', $event.currentTarget.checked);
        },
    },
};

/* script */
var __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-checkbox base-checkbox",class:{ 'is-checked': _vm.value }},[_c('div',{staticClass:"input-wrapper"},[_c('div',{staticClass:"base-checkbox-indicator"},[_vm._t("indicator"),_vm._v(" "),_c('input',_vm._g({attrs:{"type":"checkbox","id":_vm.uid,"disabled":typeof _vm.field.disabled === 'function' ? _vm.field.disabled() : _vm.field.disabled},domProps:{"checked":_vm.value},on:{"change":function($event){return _vm.handleChange($event, _vm.field)}}},_vm.$listeners))],2)]),_vm._v(" "),_c('label',{attrs:{"for":_vm.uid}},[_c('span',{staticClass:"label-text",domProps:{"innerHTML":_vm._s(_vm.field.label)}})]),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e()])};
var __vue_staticRenderFns__$2 = [];

  /* style */
  var __vue_inject_styles__$2 = undefined;
  /* scoped */
  var __vue_scope_id__$2 = undefined;
  /* module identifier */
  var __vue_module_identifier__$2 = undefined;
  /* functional template */
  var __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$2 = normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    undefined,
    undefined,
    undefined
  );

var script$3 = {
    name: 'FieldRadio',

    props: {
        field: {
            type: Object,
            required: true,
        },

        value: {
            type: String,
        },
    },

    methods: {
        handleChange: function handleChange($event) {
            this.$emit('valueChange', $event.currentTarget.value);
        },
    },
};

/* script */
var __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-radio base-radio"},[_vm._l((_vm.field.choices),function(choice){return _c('label',{key:choice.name,class:[choice.classname, { 'is-checked': _vm.value === choice.value }]},[_c('input',_vm._g({attrs:{"type":"radio","name":_vm.field.model,"disabled":typeof choice.disabled === 'function' ? choice.disabled() : choice.disabled},domProps:{"value":choice.value,"checked":_vm.value === choice.value},on:{"change":function($event){return _vm.handleChange($event, _vm.field)}}},_vm.$listeners)),_vm._v(" "),_c('div',{staticClass:"label-text",domProps:{"innerHTML":_vm._s(choice.name)}})])}),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e()],2)};
var __vue_staticRenderFns__$3 = [];

  /* style */
  var __vue_inject_styles__$3 = undefined;
  /* scoped */
  var __vue_scope_id__$3 = undefined;
  /* module identifier */
  var __vue_module_identifier__$3 = undefined;
  /* functional template */
  var __vue_is_functional_template__$3 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$3 = normalizeComponent(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    false,
    undefined,
    undefined,
    undefined
  );

function addOrRemove(array, value) {
    var clone = [].concat( (array || []) );
    var index = clone.indexOf(value);

    if (index === -1) {
        clone.push(value);
    } else {
        clone.splice(index, 1);
    }

    return clone
}

var script$4 = {
    name: 'FieldChecklist',

    props: {
        field: {
            type: Object,
            required: true,
        },

        value: {
            type: Array,
        },
    },

    methods: {
        handleChange: function handleChange($event, field, value) {
            var newValues = addOrRemove(this.value, value);
            this.$emit('valueChange', newValues);
        },
    },
};

/* script */
var __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-checklist base-checklist"},[_vm._l((_vm.field.choices),function(choice){return _c('label',{key:choice.value,class:[choice.classname, { 'is-checked': _vm.value ? _vm.value.includes(choice.value) : false }]},[_c('input',_vm._g({attrs:{"disabled":typeof choice.disabled === 'function' ? choice.disabled() : choice.disabled,"type":"checkbox"},domProps:{"checked":_vm.value ? _vm.value.includes(choice.value) : false,"value":choice.value},on:{"change":function($event){return _vm.handleChange($event, _vm.field, choice.value)}}},_vm.$listeners)),_vm._v(" "),_c('div',{staticClass:"label-text",domProps:{"innerHTML":_vm._s(choice.name)}})])}),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e()],2)};
var __vue_staticRenderFns__$4 = [];

  /* style */
  var __vue_inject_styles__$4 = undefined;
  /* scoped */
  var __vue_scope_id__$4 = undefined;
  /* module identifier */
  var __vue_module_identifier__$4 = undefined;
  /* functional template */
  var __vue_is_functional_template__$4 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$4 = normalizeComponent(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    false,
    undefined,
    undefined,
    undefined
  );

var script$5 = {
    name: 'FieldSelect',

    props: {
        field: {
            type: Object,
            required: true,
        },

        value: {
            type: [String, Number],
        },
    },

    data: function data() {
        return {
            uid: undefined
        }
    },

    mounted: function mounted() {
        var inBrowser = typeof window !== 'undefined';
        if (inBrowser) {
            this.uid = this.field.type + '' + Math.random();
        }
    },

    methods: {
        handleChange: function handleChange($event) {
            this.$emit('valueChange', $event.currentTarget.value);
        },
    },
};

/* script */
var __vue_script__$5 = script$5;

/* template */
var __vue_render__$5 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-select base-select",class:{ 'has-value': _vm.value }},[_c('label',{attrs:{"for":_vm.uid}},[_c('span',{staticClass:"label-text",domProps:{"innerHTML":_vm._s(_vm.field.label)}})]),_vm._v(" "),_c('div',{staticClass:"select-wrapper"},[_c('select',_vm._g({attrs:{"id":_vm.uid,"disabled":typeof _vm.field.disabled === 'function' ? _vm.field.disabled() : _vm.field.disabled},domProps:{"value":_vm.value},on:{"change":function($event){return _vm.handleChange($event, _vm.field)}}},_vm.$listeners),[_c('option',{attrs:{"hidden":"","disabled":"","selected":"","value":""}},[_vm._v(_vm._s(_vm.field.placeholder))]),_vm._v(" "),_vm._l((_vm.field.choices),function(choice){return _c('option',{key:choice.value,attrs:{"disabled":typeof choice.disabled === 'function' ? choice.disabled() : choice.disabled},domProps:{"value":choice.value}},[_vm._v("\n                "+_vm._s(choice.name)+"\n            ")])})],2)]),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e()])};
var __vue_staticRenderFns__$5 = [];

  /* style */
  var __vue_inject_styles__$5 = undefined;
  /* scoped */
  var __vue_scope_id__$5 = undefined;
  /* module identifier */
  var __vue_module_identifier__$5 = undefined;
  /* functional template */
  var __vue_is_functional_template__$5 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$5 = normalizeComponent(
    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
    __vue_inject_styles__$5,
    __vue_script__$5,
    __vue_scope_id__$5,
    __vue_is_functional_template__$5,
    __vue_module_identifier__$5,
    false,
    undefined,
    undefined,
    undefined
  );

var script$6 = {
    name: 'FieldNumericInput',

    props: {
        field: {
            type: Object,
            required: true,
        },

        value: {
            type: String,
        },
    },

    data: function data () {
        return {
            focused: false,
            uid: undefined
        }
    },

    mounted: function mounted() {
        var inBrowser = typeof window !== 'undefined';
        if (inBrowser) {
            this.uid = this.field.type + '' + Math.random();
        }
    },

    methods: {
        handleInput: function handleInput($event) {
            var value = $event.target.value.replace(/[^\d]/g, '');
            if (value === this.value) {
                $event.target.value = value;
            } else {
                this.$emit('valueChange', value);
            }
        },
    },
};

/* script */
var __vue_script__$6 = script$6;

/* template */
var __vue_render__$6 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-numeric-input base-input",class:{ 'has-value': _vm.value && _vm.value.length, 'focused': _vm.focused }},[_c('label',{attrs:{"for":_vm.uid}},[_c('span',{staticClass:"label-text",domProps:{"innerHTML":_vm._s(_vm.field.label)}})]),_vm._v(" "),_c('div',{staticClass:"input-wrapper"},[_c('input',_vm._g({attrs:{"id":_vm.uid,"placeholder":_vm.field.placeholder,"minlength":_vm.field.minlength,"maxlength":_vm.field.maxlength,"size":_vm.field.size,"spellcheck":_vm.field.spellcheck ? 'true' : 'false',"autocomplete":_vm.field.autocomplete ? _vm.field.autocomplete : 'new-password',"disabled":typeof _vm.field.disabled === 'function' ? _vm.field.disabled() : _vm.field.disabled,"type":'tel'},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.handleInput($event, _vm.field)},"focus":function($event){_vm.focused = true;},"blur":function($event){_vm.focused = false;}}},_vm.$listeners))]),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e()])};
var __vue_staticRenderFns__$6 = [];

  /* style */
  var __vue_inject_styles__$6 = undefined;
  /* scoped */
  var __vue_scope_id__$6 = undefined;
  /* module identifier */
  var __vue_module_identifier__$6 = undefined;
  /* functional template */
  var __vue_is_functional_template__$6 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$6 = normalizeComponent(
    { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
    __vue_inject_styles__$6,
    __vue_script__$6,
    __vue_scope_id__$6,
    __vue_is_functional_template__$6,
    __vue_module_identifier__$6,
    false,
    undefined,
    undefined,
    undefined
  );

var debounce = function (callback, time, interval) {
    if ( time === void 0 ) time = 250;

    return function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        clearTimeout(interval);
        interval = setTimeout(function () {
            callback.apply(void 0, args);
        }, time);
    }
};

// Takes 2 types of value :
// 1. string when the user types
// 2. object when the user clicks a result
// maybe create a validator to only allow "object" values

var script$7 = {
    name: 'FieldZipcode',

    props: {
        field: {
            type: Object,
            required: true,
        },

        value: {
            type: [String, Object],
        },
    },

    data: function data() {
        return {
            debouncedFetch: undefined,
            results: undefined,
            focused: undefined,
            clickedOutside: undefined,
            loading: undefined,
            autoSelected: undefined,
            uid: undefined,
        }
    },

    computed: {
        open: function open() {
            return this.focused && !this.clickedOutside && this.results && this.results.length > 1
        },

        displayableValue: function displayableValue() {
            if (typeof this.value === 'object') {
                return ((this.value.cpCode) + " - " + (this.value.communeLib))
            } else {
                return this.value
            }
        }
    },

    watch: {
        value: {
            handler: function () {
                if (typeof this.value === 'object') {
                    return
                }
                if (!this.value || this.value.length < 3) {
                    return
                }
                if (this.debouncedFetch) {
                    this.debouncedFetch(this.value);
                }
            },

            immediate: true
        },
    },

    mounted: function mounted() {
        var inBrowser = typeof window !== 'undefined';
        if (inBrowser) {
            this.uid = this.field.type + '' + Math.random();
        }

        this.debouncedFetch = debounce(this.fetch, 600);
        document.body.addEventListener('click', this.handleClickOutside);
    },

    beforeDestroy: function beforeDestroy() {
        document.body.removeEventListener('click', this.handleClickOutside);
    },

    methods: {
        fetch: function fetch$1(input) {
            var this$1 = this;

            var endpoint = 'https://contact.acadomia.fr/api/adresse/rechercherCpCommune';

            this.loading = true;
            fetch((endpoint + "/?cpCommune=" + input))
                .then(function (response) { return response.json(); })
                .then(function (json) { return json; }).then(function (ref) {
                    var cpCommunes = ref.cpCommunes;

                    this$1.results = cpCommunes;

                    if (this$1.results.length === 1) {
                        this$1.$emit('valueChange', this$1.results[0]);
                        this$1.autoSelected = true;
                    }

                    this$1.loading = false;
                });
        },

        handleInput: function handleInput($event) {
            if (this.autoSelected && $event.currentTarget.value.length > this.displayableValue.length) {
                this.$emit('valueChange', this.value);
            } else {
                var value = $event.currentTarget.value;
                this.$emit('valueChange', value);
                this.autoSelected = false;
                this.clickedOutside = false;
            }
        },

        handleResultClick: function handleResultClick(result) {
            this.focused = false;
            this.results = undefined;
            this.$emit('valueChange', result);
        },

        handleFocus: function handleFocus() {
            this.focused = true;
            this.clickedOutside = false;
        },

        handleBlur: function handleBlur() {
            this.focused = false;
        },

        handleClickOutside: function handleClickOutside(event) {
            if (!(this.$refs.multilist == event.target || this.$refs.multilist.contains(event.target))) {
                this.clickedOutside = true;
            }
        },
    },
};

/* script */
var __vue_script__$7 = script$7;

/* template */
var __vue_render__$7 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-zipcode base-input",class:{
    'has-value': _vm.displayableValue && _vm.displayableValue.length,
    'is-dropdown-value': typeof this.value === 'object',
    'is-loading': _vm.loading,
    'is-open': _vm.open,
    'focused': _vm.focused,
    'has-results': _vm.results && _vm.results.length > 0,
    'has-many-results': _vm.results && _vm.results.length > 1
}},[_c('label',{attrs:{"for":_vm.uid}},[_c('span',{staticClass:"label-text",domProps:{"innerHTML":_vm._s(_vm.field.label)}})]),_vm._v(" "),_c('div',{ref:"multilist",staticClass:"multilist"},[_c('div',{staticClass:"input-wrapper"},[_c('input',_vm._g({staticClass:"multilist-input",attrs:{"id":_vm.uid,"placeholder":_vm.field.placeholder,"spellcheck":_vm.field.spellcheck ? 'true' : 'false',"autocomplete":_vm.field.autocomplete ? _vm.field.autocomplete : 'new-password',"disabled":typeof _vm.field.disabled === 'function' ? _vm.field.disabled() : _vm.field.disabled,"type":"text"},domProps:{"value":_vm.displayableValue},on:{"input":function($event){return _vm.handleInput($event)},"focus":function($event){return _vm.handleFocus($event)},"blur":function($event){return _vm.handleBlur($event)}}},_vm.$listeners))]),_vm._v(" "),(_vm.open)?_c('div',{staticClass:"multilist-results"},_vm._l((_vm.results),function(result){return _c('div',{key:result.cpId + '-' + result.communeId,staticClass:"multilist-result",on:{"mousedown":function($event){return _vm.handleResultClick(result)}}},[_vm._v("\n                "+_vm._s(result.cpCode)+" - "+_vm._s(result.communeLib)+"\n            ")])}),0):_vm._e()]),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e()])};
var __vue_staticRenderFns__$7 = [];

  /* style */
  var __vue_inject_styles__$7 = undefined;
  /* scoped */
  var __vue_scope_id__$7 = undefined;
  /* module identifier */
  var __vue_module_identifier__$7 = undefined;
  /* functional template */
  var __vue_is_functional_template__$7 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$7 = normalizeComponent(
    { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
    __vue_inject_styles__$7,
    __vue_script__$7,
    __vue_scope_id__$7,
    __vue_is_functional_template__$7,
    __vue_module_identifier__$7,
    false,
    undefined,
    undefined,
    undefined
  );

function normalize (text) {
    var noAccent = text.normalize("NFD").replace(/[\u0300-\u036f]/g, '');
    return noAccent.replace(/\s\s+/g, ' ').toLowerCase().trim()
}

function extractRepetition (numberAndRepetition) {
    var number = '';
    var repetition = ''

    ;[].concat( numberAndRepetition ).forEach(function (c) {
        if (/\d/.test(c) && !repetition.length) {
            number += c;
        } else {
            repetition += c;
        }
    });

    return {
        number: number.trim(),
        repetition: repetition.trim(),
    }
}

function slugify (text) {
    if (!text) { return '' }
    return text
        .toString()
        // split an accented letter in the base letter and the acent
        .normalize( 'NFD' )
        // remove all previously split accents
        .replace( /[\u0300-\u036f]/g, '' )
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')
        // eslint-disable-next-line no-useless-escape
        .replace(/[^\w\-]+/g, '')
        // eslint-disable-next-line no-useless-escape
        .replace(/\-\-+/g, '-')
}

var script$8 = {
    name: 'FieldGoogleAddress',

    props: {
        field: {
            type: Object,
            required: true,
        },

        value: {
            type: [String, Object],
        },
    },

    data: function data() {
        return {
            autocomplete: undefined,
            focused: undefined,
            loading: undefined,
            uid: undefined,
        }
    },

    computed: {
        displayableValue: function displayableValue() {
            if (typeof this.value === 'object') {
                return ("" + (this.value.rawGooglePlace.formatted_address))
            } else {
                return this.value
            }
        }
    },

    mounted: function mounted() {
        var this$1 = this;

        var inBrowser = typeof window !== 'undefined';
        if (inBrowser) {
            this.uid = this.field.type + '' + Math.random();
        }

        loadGoogleMapsApi({
            key: 'AIzaSyCWsbZxeOvV8ZjBUglp2xumatSzuXCpANQ',
            libraries: ['places'],
        }).then(function (googleMaps) {
            var input = this$1.$refs['searchTextField'];
            var options = {
                types: this$1.field.placeTypes || []
            };

            this$1.autocomplete = new googleMaps.places.Autocomplete(
                input,
                options
            );

            this$1.autocomplete.setComponentRestrictions(this$1.field.restrictions || {
                'country': ['fr']
            });

            this$1.autocomplete.setFields(['address_components', 'formatted_address']);

            googleMaps.event.addListener(this$1.autocomplete, 'place_changed', this$1.handlePlaceChanged);
        });
    },

    methods: {
        handlePlaceChanged: function handlePlaceChanged() {
            var this$1 = this;

            var place = this.autocomplete.getPlace();

            var parsedComponents = this.parseComponents(place.address_components);

            this.fetchCities(parsedComponents.googleZipcode || parsedComponents.googleCityName).then(function (ref) {
                var cpCommunes = ref.cpCommunes;

                var city = this$1.getBestCity(cpCommunes, parsedComponents.googleCityName);

                parsedComponents.city = city;
                parsedComponents.rawGooglePlace = place;

                this$1.$emit('valueChange', parsedComponents);
            });
        },

        handleInput: function handleInput($event) {
            var value = $event.target.value;
            this.$emit('valueChange', value);
        },

        handleFocus: function handleFocus() {
            this.focused = true;
        },

        handleBlur: function handleBlur() {
            this.focused = false;
        },

        fetchCities: function fetchCities(input) {
            var endpoint = 'https://contact.acadomia.fr/api/adresse/rechercherCpCommune';

            return fetch((endpoint + "/?cpCommune=" + input))
                .then(function (response) { return response.json(); })
                .then(function (json) { return json; })
        },

        getBestCity: function getBestCity (cities, cityName) {
            if (cities.length === 1) {
                return cities[0]
            }

            return cities.find(function (city) {
                return slugify(city.communeLib) === slugify(cityName)
            })
        },

        parseComponents: function parseComponents (googleComponents) {
            if (!googleComponents) { return undefined }

            var components = {};

            // repetition
            var streetNumberRaw = googleComponents.find(function (component) {
                return component.types.includes('street_number')
            });

            if (streetNumberRaw) {
                var streetNumberNormalized = normalize(streetNumberRaw.short_name);

                var ref = extractRepetition(streetNumberNormalized);
                var number = ref.number;
                var repetition = ref.repetition;

                components.repetition = repetition;
                components.number = number;
            }

            // route type
            var routeRaw = googleComponents.find(function (component) {
                return component.types.includes('route')
            });

            if (routeRaw) {
                var routeNormalized = normalize(routeRaw.short_name);

                components.routeType = routeNormalized.split(' ')[0];

                // route name
                components.routeName = routeNormalized.replace(components.routeType, '').trim();
            }

            // city name
            var localityRaw = googleComponents.find(function (component) {
                return component.types.includes('locality')
            });

            if (localityRaw) {
                components.googleCityName = localityRaw.long_name;
            }

            // zipcode
            var postalCodeRaw = googleComponents.find(function (component) {
                return component.types.includes('postal_code')
            });

            if (postalCodeRaw) {
                components.googleZipcode = postalCodeRaw.short_name;
            }

            // country
            var countryRaw = googleComponents.find(function (component) {
                return component.types.includes('country')
            });

            if (countryRaw) {
                components.country = countryRaw.long_name;
            }

            return components
        }
    },
};

/* script */
var __vue_script__$8 = script$8;

/* template */
var __vue_render__$8 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-google-address base-input",class:{
    'has-value': _vm.displayableValue && _vm.displayableValue.length,
    'is-loading': _vm.loading,
    'focused': _vm.focused
}},[_c('label',{attrs:{"for":_vm.uid}},[_c('span',{staticClass:"label-text",domProps:{"innerHTML":_vm._s(_vm.field.label)}})]),_vm._v(" "),_c('div',{staticClass:"input-wrapper"},[_c('input',_vm._g({ref:"searchTextField",attrs:{"id":_vm.uid,"placeholder":_vm.field.placeholder,"disabled":typeof _vm.field.disabled === 'function' ? _vm.field.disabled() : _vm.field.disabled,"type":"text"},domProps:{"value":_vm.displayableValue},on:{"focus":function($event){return _vm.handleFocus($event)},"blur":function($event){return _vm.handleBlur($event)},"input":function($event){return _vm.handleInput($event)}}},_vm.$listeners))]),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e()])};
var __vue_staticRenderFns__$8 = [];

  /* style */
  var __vue_inject_styles__$8 = undefined;
  /* scoped */
  var __vue_scope_id__$8 = undefined;
  /* module identifier */
  var __vue_module_identifier__$8 = undefined;
  /* functional template */
  var __vue_is_functional_template__$8 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$8 = normalizeComponent(
    { render: __vue_render__$8, staticRenderFns: __vue_staticRenderFns__$8 },
    __vue_inject_styles__$8,
    __vue_script__$8,
    __vue_scope_id__$8,
    __vue_is_functional_template__$8,
    __vue_module_identifier__$8,
    false,
    undefined,
    undefined,
    undefined
  );

function getBase64(file) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () { return resolve(reader.result); };
        reader.onerror = function (error) { return reject(error); };
    })
}
var script$9 = {
    name: 'FieldUpload',

    props: {
        field: {
            type: Object,
            required: true,
        },

        value: {
            type: Array,
        },
    },

    data: function data () {
        return {
            dragover: undefined,
            focused: false,
            uid: undefined
        }
    },

    mounted: function mounted() {
        var this$1 = this;

        var inBrowser = typeof window !== 'undefined';
        if (inBrowser) {
            this.uid = this.field.type + '' + Math.random();
        }

        ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (eventName) {
            this$1.$el.addEventListener(eventName, function (e) {
                e.preventDefault();
                e.stopPropagation();
            });
        });

        ['dragover', 'dragenter'].forEach(function (eventName) {
            this$1.$el.addEventListener(eventName, function () {
                this$1.dragover = true;
            });
        });

        ['dragleave', 'dragend', 'drop'].forEach(function (eventName) {
            this$1.$el.addEventListener(eventName, function () {
                this$1.dragover = false;
            });
        });

        ['drop'].forEach(function (eventName) {
            this$1.$el.addEventListener(eventName, function (e) {
                this$1.handleFiles(e.dataTransfer.files);
            });
        });
    },

    methods: {
        handleFiles: function handleFiles(files) {
            var this$1 = this;

            if (this.field.multiple) {
                files.forEach(function (file) {
                    getBase64(file).then(function (base64) {
                        var clone = (this$1.value || []).slice(0);
                        clone.push({
                            file: file,
                            base64: base64,
                        });
                        this$1.$emit('valueChange', clone);
                    });
                });
            } else {
                getBase64(files[0]).then(function (base64) {
                    this$1.$emit('valueChange', [{
                        file: files[0],
                        base64: base64,
                    }]);
                });
            }
        },

        handleInputChange: function handleInputChange($event) {
            var files = $event.currentTarget.files;
            this.handleFiles(files);
        },

        handleRemoveClick: function handleRemoveClick(index) {
            var clone = (this.value || []).slice(0);
            clone.splice(index, 1);
            this.$emit('valueChange', clone);
        },
    },
};

/* script */
var __vue_script__$9 = script$9;

/* template */
var __vue_render__$9 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-upload base-upload",class:{ 'has-value': _vm.value && _vm.value.length, 'is-dragover': _vm.dragover, 'focused': _vm.focused }},[_c('label',{attrs:{"for":_vm.uid}},[_c('span',{staticClass:"label-text",domProps:{"innerHTML":_vm._s(_vm.field.label)}})]),_vm._v(" "),_c('div',{staticClass:"input-wrapper"},[_c('input',_vm._g({ref:"input",attrs:{"type":"file","id":_vm.uid,"multiple":_vm.field.multiple,"disabled":typeof _vm.field.disabled === 'function' ? _vm.field.disabled() : _vm.field.disabled,"accept":_vm.field.accept},on:{"change":function($event){return _vm.handleInputChange($event)},"focus":function($event){_vm.focused = true;},"blur":function($event){_vm.focused = false;}}},_vm.$listeners))]),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"files"},_vm._l((_vm.value),function(file,i){return _c('div',{key:file.file.name,staticClass:"file"},[_c('span',{staticClass:"file-name"},[_vm._v(_vm._s(file.file.name))]),_vm._v(" "),_c('span',{staticClass:"file-remove",on:{"click":function($event){return _vm.handleRemoveClick(i)}}},[_vm._v("×")])])}),0)])};
var __vue_staticRenderFns__$9 = [];

  /* style */
  var __vue_inject_styles__$9 = undefined;
  /* scoped */
  var __vue_scope_id__$9 = undefined;
  /* module identifier */
  var __vue_module_identifier__$9 = undefined;
  /* functional template */
  var __vue_is_functional_template__$9 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$9 = normalizeComponent(
    { render: __vue_render__$9, staticRenderFns: __vue_staticRenderFns__$9 },
    __vue_inject_styles__$9,
    __vue_script__$9,
    __vue_scope_id__$9,
    __vue_is_functional_template__$9,
    __vue_module_identifier__$9,
    false,
    undefined,
    undefined,
    undefined
  );

var script$a = {
    name: 'FieldProgressBar',

    props: {
        field: {
            type: Object,
            required: true,
        },

        value: {
            type: [String, Number],
        },
    },

    data: function data () {
        return {
            focused: false,
        }
    },

    methods: {
        getProgressPercent: function getProgressPercent(field) {
            var currentStep = parseFloat(field.currentStep);
            var totalSteps = parseFloat(field.totalSteps);
            var percent = (currentStep-1)/(totalSteps-1);
            return percent
        },


        handleProgressBarStepClick: function handleProgressBarStepClick(step) {
            this.$emit('valueChange', step);
        }
    },
};

/* script */
var __vue_script__$a = script$a;

/* template */
var __vue_render__$a = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-progress-bar base-progress-bar"},[_c('div',{staticClass:"progress-bar-background"},[_c('div',{staticClass:"progress-bar-foreground",style:({
            width: _vm.getProgressPercent(_vm.field) * 100 +'%'
             })})]),_vm._v(" "),_vm._l((parseInt(_vm.field.totalSteps)),function(step){return [(parseInt(step) < Math.floor(_vm.field.currentStep))?_c('div',{key:step,staticClass:"progress-bar-step past",on:{"click":function($event){return _vm.handleProgressBarStepClick(step)}}},[(_vm.field.progressBarStepTitles[step])?_c('span',{staticClass:"progress-bar-step-title"},[_vm._v("\n                "+_vm._s(_vm.field.progressBarStepTitles[step])+"\n            ")]):_vm._e()]):(parseInt(step) === Math.floor(_vm.field.currentStep))?_c('div',{key:step,staticClass:"progress-bar-step active"},[(_vm.field.progressBarStepTitles[step])?_c('span',{staticClass:"progress-bar-step-title"},[_vm._v("\n                "+_vm._s(_vm.field.progressBarStepTitles[step])+"\n            ")]):_vm._e()]):_c('div',{key:step,staticClass:"progress-bar-step"},[(_vm.field.progressBarStepTitles[step])?_c('span',{staticClass:"progress-bar-step-title"},[_vm._v("\n                "+_vm._s(_vm.field.progressBarStepTitles[step])+"\n            ")]):_vm._e()])]})],2)};
var __vue_staticRenderFns__$a = [];

  /* style */
  var __vue_inject_styles__$a = undefined;
  /* scoped */
  var __vue_scope_id__$a = undefined;
  /* module identifier */
  var __vue_module_identifier__$a = undefined;
  /* functional template */
  var __vue_is_functional_template__$a = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$a = normalizeComponent(
    { render: __vue_render__$a, staticRenderFns: __vue_staticRenderFns__$a },
    __vue_inject_styles__$a,
    __vue_script__$a,
    __vue_scope_id__$a,
    __vue_is_functional_template__$a,
    __vue_module_identifier__$a,
    false,
    undefined,
    undefined,
    undefined
  );

var radiusZoom = {
    5: 10,
    10: 9.5,
    15: 9,
    20: 8.5,
    25: 8.5,
    30: 8,
};

var script$b = {
    name: 'FieldMultiZipcode',

    components: {
        BaseZipcode: BaseZipcode,
        BaseTaglist: BaseTaglist,
    },

    props: {
        value: {
            type: [Array],
        },
        componentOptions: {
            type: Object,
            default: function default$1() {
                return {}
            }
        },
    },

    data: function data () {
        return {
            allCities: [],
            radius: 5,
            circle: undefined,
            marker: undefined,
            map: undefined,
            geocoder: undefined,
            typedValue: undefined,
            googleMaps: undefined,
            googleMarker: undefined,
            google: undefined
        }
    },

    computed: {
        allCitiesWithRadius: function allCitiesWithRadius() {
            var this$1 = this;

            return this.allCities.map(function (city) {
                return Object.assign({}, city, {
                    radius: this$1.radius
                })
            })
        }
    },

    watch: {
        radius: {
            handler: function () {
                if (!this.circle) { return }
                this.circle.setRadius(this.radius * 1000);
                this.map.setZoom(radiusZoom[this.radius]);
            }
        },

        allCitiesWithRadius: {
            handler: function (cities, prevCities) {
                var this$1 = this;

                this.$emit('valueChange', this.allCitiesWithRadius);

                if (cities.length === 1 && prevCities.length !== 1) {
                    this.geocode(cities[0]).then(function (coords) {
                        this$1.drawMarker({ lat: coords.lat(), lng: coords.lng() });
                        this$1.typedValue = '';
                    });
                }

                if (cities.length !== prevCities.length) {
                    this.typedValue = '';
                }
            }
        }
    },
    mounted: function mounted() {
        var this$1 = this;

        if (this.value && this.value.length) {
            this.allCities = this.value;
        }
        if (this.value && this.value.length) {
            this.radius = this.value[0].radius;
        }

        var loader = new Loader({
            apiKey: 'AIzaSyCWsbZxeOvV8ZjBUglp2xumatSzuXCpANQ',
            version: "weekly",
            libraries: ["maps", 'geocoding', 'marker']
        });
        this.google = loader.load().then(function (google) {
            this$1.google = google;
            this$1.initMap();
        });
    },


    methods: {
        initMap: function initMap() {
            var this$1 = this;

            this.map = new this.google.maps.Map(this.$refs.map, {
                zoom: 9,
                disableDefaultUI: true,
                zoomControl: false,
                streetViewControl: false,
                mapTypeControl: false,
                fullscreenControl: false,
                center: { lat: 48.866667, lng: 2.333333 }
            });

            this.geocoder = new this.google.maps.Geocoder();

            if (this.allCities && this.allCities.length) {
                this.geocode(this.allCities[0]).then(function (coords) {
                    this$1.drawMarker({ lat: coords.lat(), lng: coords.lng() });
                });
            }
        },

        geocode: function geocode(city) {
            var this$1 = this;

            return new Promise(function (resolve, reject) {
                if (!this$1.geocoder) { reject(); }
                this$1.geocoder.geocode({ 'address': ((city.cpCode) + " " + (city.communeLib)) }, function(results, status) {
                    if (status === 'OK') {
                        resolve(results[0].geometry.location);
                    } else {
                        reject(status);
                    }
                });
            })
        },

        drawMarker: function drawMarker(coords) {
            var svgMarker = "\n                <svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 26 26\">\n                  <path fill=\"#007AFF\" d=\"M13 8a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm0 8a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z\"/>\n                  <path fill=\"#007AFF\" d=\"M25 12h-2a10 10 0 0 0-9-9V1a1 1 0 0 0-2 0v2a10 10 0 0 0-9 9H1a1 1 0 0 0 0 2h2a10 10 0 0 0 9 9v2a1 1 0 0 0 2 0v-2a10 10 0 0 0 9-9h2a1 1 0 0 0 0-2Zm-11 9a1 1 0 0 0-2 0 8 8 0 0 1-7-7 1 1 0 0 0 0-2 8 8 0 0 1 7-7 1 1 0 0 0 2 0 8 8 0 0 1 7 7 1 1 0 0 0 0 2 8 8 0 0 1-7 7Z\"/>\n                </svg>\n            ";

            if (this.marker) {
                this.marker.setMap(null);
            }
            if (this.circle) {
                this.circle.setMap(null);
            }

            this.marker = new this.google.maps.Marker({
                position: coords,
                map: this.map,
                title: 'SVG Marker!',
                icon: {
                    url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svgMarker),
                    scaledSize: new this.google.maps.Size(26, 26),
                    anchor: new this.google.maps.Point(13, 13)
                }
            });

            this.circle = new this.google.maps.Circle({
                strokeColor: '#007AFF',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: '#007AFF',
                fillOpacity: 0.2,
                map: this.map,
                center: coords,
                radius: this.radius * 1000,
            });

            this.map.setCenter(coords);
            this.map.setZoom(radiusZoom[this.radius]);

        },

        handleValueChange: function handleValueChange(value) {
            this.typedValue = value;

            if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
                this.allCities.push(value);
            }
        },
        handleTagsChange: function handleTagsChange(tag) {
            var index = this.allCities.indexOf(tag);
            if (index >= 0) {
                this.allCities.splice(index, 1);
            }
        },

        handleRangeInput: function handleRangeInput($event) {
            this.radius = parseInt($event.target.value);
        },
    },
};

/* script */
var __vue_script__$b = script$b;

/* template */
var __vue_render__$b = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-multi-zipcode base-multi-zipcode"},[_c('BaseZipcode',_vm._b({staticStyle:{"margin-bottom":"10px"},attrs:{"value":_vm.typedValue},on:{"focus":function ($event) { return _vm.$emit('focus', $event); },"blur":function ($event) { return _vm.$emit('blur', $event); },"valueChange":_vm.handleValueChange},nativeOn:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();}}},'BaseZipcode',_vm.$attrs,false),[_c('template',{slot:"label"},[_vm._t("label")],2),_vm._v(" "),_c('template',{slot:"after"},[_vm._t("after")],2)],2),_vm._v(" "),_c('BaseTaglist',{staticStyle:{"margin-bottom":"10px"},attrs:{"values":_vm.allCities,"prefix":_vm.componentOptions.prefix,"trackBy":'cpCode',"tagValue":'communeLib',"tagClassname":_vm.componentOptions.tagClassname,"tagsClassname":_vm.componentOptions.tagsClassname},on:{"change":_vm.handleTagsChange}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allCities && _vm.allCities.length === 1),expression:"allCities && allCities.length === 1"}]},[_c('div',{staticClass:"range-wrapper"},[_c('label',{attrs:{"for":"range"}},[_vm._v("Dans un rayon de "),_c('span',{staticStyle:{"color":"var(--AkBlueNoteLight)"}},[_vm._v(_vm._s(_vm.radius)+"km")])]),_vm._v(" "),_c('input',{attrs:{"type":"range","id":"range","name":"range","min":"0","max":"30","step":"5"},domProps:{"value":_vm.radius},on:{"input":_vm.handleRangeInput,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();}}})]),_vm._v(" "),_c('div',{ref:"map",staticClass:"map"})])],1)};
var __vue_staticRenderFns__$b = [];

  /* style */
  var __vue_inject_styles__$b = undefined;
  /* scoped */
  var __vue_scope_id__$b = undefined;
  /* module identifier */
  var __vue_module_identifier__$b = undefined;
  /* functional template */
  var __vue_is_functional_template__$b = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$b = normalizeComponent(
    { render: __vue_render__$b, staticRenderFns: __vue_staticRenderFns__$b },
    __vue_inject_styles__$b,
    __vue_script__$b,
    __vue_scope_id__$b,
    __vue_is_functional_template__$b,
    __vue_module_identifier__$b,
    false,
    undefined,
    undefined,
    undefined
  );

var script$c = {

    name: 'Fields',

    inheritAttrs: false,

    components: {
        ClientOnly: ClientOnly,

        BaseChecklist: BaseChecklist,
        BaseTaglist: BaseTaglist,
        BaseSelect: BaseSelect,
        BaseCheckbox: BaseCheckbox,
        BaseRadio: BaseRadio,
        BaseInput: BaseInput,
        BaseTextarea: BaseTextarea,
        BaseAddress: BaseAddress,
        BasePhoneNumber: BasePhoneNumber,
        BaseProgressBar: BaseProgressBar,
        BaseZipcode: BaseZipcode,
        BaseFileUpload: BaseFileUpload,
        BaseMultiSelect: BaseMultiSelect,
        BaseButton: BaseButton,
        IconCross: IconCross,
        IconDone: IconDone,

        FieldInput: __vue_component__,
        FieldTextarea: __vue_component__$1,
        FieldCheckbox: __vue_component__$2,
        FieldRadio: __vue_component__$3,
        FieldChecklist: __vue_component__$4,
        FieldSelect: __vue_component__$5,
        FieldNumericInput: __vue_component__$6,
        FieldZipcode: __vue_component__$7,
        FieldGoogleAddress: __vue_component__$8,
        FieldProgressBar: __vue_component__$a,
        FieldUpload: __vue_component__$9,
        FieldMultiZipcode: __vue_component__$b,
    },

    props: {
        field: {
            type: Object,
            required: true
        },
        model: {
            type: Object,
        },
        errors: {
            type: Object,
        },
        hasFieldVisibleError: {
            type: Function,
            required: true
        },
        hasFieldError: {
            type: Function,
            required: true
        },
        isFieldVisible: {
            type: Function,
            required: true
        },
        getProps: {
            type: Function,
            required: true
        },
        getMultiSelectProps: {
            type: Function,
            required: true
        },
        getTaglistProps: {
            type: Function,
            required: true
        },
    },

    data: function data () {
        return {

        }
    },

    methods: {
    },

};

/* script */
var __vue_script__$c = script$c;

/* template */
var __vue_render__$c = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("form-generator-field field-" + (_vm.field.type) + "-wrapper " + (_vm.field.classname || '') + " " + (_vm.hasFieldVisibleError(_vm.field) ? 'has-visible-errors' : '') + " " + (_vm.hasFieldError(_vm.field) ? 'has-errors' : ''))},[(_vm.field.type === 'group')?_vm._t("group",_vm._l((_vm.field.groupFields),function(groupField,i){return _c('Fields',_vm._g(_vm._b({key:i + '_' + groupField.type,attrs:{"field":groupField}},'Fields',_vm.$props,false),_vm.$listeners))}),{"value":_vm.model[_vm.field.model],"field":_vm.field},_vm.getProps(_vm.field)):(_vm.field.type === 'checklist')?_vm._t("checklist",[_c('BaseChecklist',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"values":_vm.model[_vm.field.model],"options":_vm.field.choices},on:{"change":function ($event) { return _vm.$emit('checklistValueChange', { $event: $event, field: _vm.field }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }},scopedSlots:_vm._u([(_vm.field.label && _vm.field.label.length)?{key:"before",fn:function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.field.label)}})]},proxy:true}:null,{key:"label",fn:function(ref){
var option = ref.option;
return [_c('div',{domProps:{"innerHTML":_vm._s(option.name)}})]}}],null,true)},'BaseChecklist',_vm.getProps(_vm.field),false)),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e()],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'taglist')?_vm._t("taglist",[_c('BaseTaglist',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"values":_vm.field.referenceTo ? _vm.model[_vm.field.referenceTo] : _vm.model[_vm.field.model]},on:{"change":function (value) { return _vm.$emit('taglistValueChange', { field: _vm.field, value: value }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }}},'BaseTaglist',_vm.getTaglistProps(_vm.field),false)),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e()],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'select')?_vm._t("select",[_c('BaseSelect',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"value":_vm.model[_vm.field.model],"options":_vm.field.choices},on:{"change":function ($event) { return _vm.$emit('valueChange', { field: _vm.field, value: $event.currentTarget.value }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }}},'BaseSelect',_vm.getProps(_vm.field),false),[_c('span',{attrs:{"slot":"label"},domProps:{"innerHTML":_vm._s(_vm.field.label)},slot:"label"})]),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e()],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'checkbox')?_vm._t("checkbox",[_c('BaseCheckbox',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"checked":_vm.model[_vm.field.model],"options":_vm.field.choices},on:{"change":function (value) { return _vm.$emit('valueChange', { field: _vm.field, value: value }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }}},'BaseCheckbox',_vm.getProps(_vm.field),false),[_c('span',{attrs:{"slot":"label"},domProps:{"innerHTML":_vm._s(_vm.field.label)},slot:"label"})]),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e()],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'radio')?_vm._t("radio",[_c('BaseRadio',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"name":_vm.field.model,"value":_vm.model[_vm.field.model],"options":_vm.field.choices},on:{"click":function($event){_vm.field.listeners && _vm.field.listeners.click ? _vm.field.listeners.click($event, _vm.field, _vm.model) : function () {};},"change":function ($event) { return _vm.$emit('valueChange', { field: _vm.field, value: $event.currentTarget.value }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }},scopedSlots:_vm._u([{key:"label",fn:function(ref){
var option = ref.option;
return [_c('div',{domProps:{"innerHTML":_vm._s(option.name)}})]}},{key:"after-option",fn:function(ref){
var option = ref.option;
return [_c('IconDone',{staticStyle:{"width":"20px"}})]}}])},'BaseRadio',_vm.getProps(_vm.field),false),[_c('span',{attrs:{"slot":"main-label"},domProps:{"innerHTML":_vm._s(_vm.field.label)},slot:"main-label"})]),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e()],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'input')?_vm._t("input",[_c('BaseInput',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"value":_vm.model[_vm.field.model],"placeholder":_vm.field.placeholder},on:{"input":function ($event) { return _vm.$emit('valueChange', { field: _vm.field, value: $event.currentTarget.value }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }}},'BaseInput',_vm.getProps(_vm.field),false),[_c('span',{attrs:{"slot":"label"},domProps:{"innerHTML":_vm._s(_vm.field.label)},slot:"label"}),_vm._v(" "),(_vm.hasFieldVisibleError(_vm.field))?_c('template',{slot:"after"},[_c('IconCross',{staticStyle:{"width":"20px"}})],1):_c('template',{slot:"after"},[_c('IconDone',{staticStyle:{"width":"20px"}})],1)],2),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e()],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'textarea')?_vm._t("textarea",[_c('BaseTextarea',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"value":_vm.model[_vm.field.model],"placeholder":_vm.field.placeholder},on:{"input":function ($event) { return _vm.$emit('valueChange', { field: _vm.field, value: $event.currentTarget.value }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }}},'BaseTextarea',_vm.getProps(_vm.field),false),[_c('span',{attrs:{"slot":"label"},domProps:{"innerHTML":_vm._s(_vm.field.label)},slot:"label"})]),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e()],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'numeric-input')?_vm._t("numeric-input",[_c('BaseInput',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"type":'tel',"value":_vm.model[_vm.field.model]},on:{"input":function ($event) { return _vm.$emit('numericInputValueChange', { $event: $event, field: _vm.field }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }}},'BaseInput',_vm.getProps(_vm.field),false),[_c('span',{attrs:{"slot":"label"},domProps:{"innerHTML":_vm._s(_vm.field.label)},slot:"label"}),_vm._v(" "),(_vm.hasFieldVisibleError(_vm.field))?_c('template',{slot:"after"},[_c('IconCross',{staticStyle:{"width":"20px"}})],1):_c('template',{slot:"after"},[_c('IconDone',{staticStyle:{"width":"20px"}})],1)],2),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e()],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'date-input')?_vm._t("date-input",[_c('BaseInput',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"value":_vm.model[_vm.field.model],"placeholder":_vm.field.placeholder},on:{"input":function ($event) { return _vm.$emit('dateInputValueChange', { $event: $event, field: _vm.field }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }}},'BaseInput',_vm.getProps(_vm.field),false),[_c('span',{attrs:{"slot":"label"},domProps:{"innerHTML":_vm._s(_vm.field.label)},slot:"label"}),_vm._v(" "),(_vm.hasFieldVisibleError(_vm.field))?_c('template',{slot:"after"},[_c('IconCross',{staticStyle:{"width":"20px"}})],1):_c('template',{slot:"after"},[_c('IconDone',{staticStyle:{"width":"20px"}})],1)],2),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e()],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'google-address')?_vm._t("google-address",[_c('BaseAddress',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"value":_vm.model[_vm.field.model]},on:{"input":function ($event) { return _vm.$emit('valueChange', { field: _vm.field, value: $event.currentTarget.value }); },"addressChange":function (address) { return _vm.$emit('valueChange', { field: _vm.field, value: address }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }}},'BaseAddress',_vm.getProps(_vm.field),false),[_c('span',{attrs:{"slot":"label"},domProps:{"innerHTML":_vm._s(_vm.field.label)},slot:"label"}),_vm._v(" "),(_vm.hasFieldVisibleError(_vm.field))?_c('template',{slot:"after"},[_c('IconCross',{staticStyle:{"width":"20px"}})],1):_c('template',{slot:"after"},[_c('IconDone',{staticStyle:{"width":"20px"}})],1)],2),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e()],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'zipcode')?_vm._t("zipcode",[_c('BaseZipcode',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"value":_vm.model[_vm.field.model]},on:{"valueChange":function (value) { return _vm.$emit('valueChange', { field: _vm.field, value: value }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }}},'BaseZipcode',_vm.getProps(_vm.field),false),[_c('span',{attrs:{"slot":"label"},domProps:{"innerHTML":_vm._s(_vm.field.label)},slot:"label"}),_vm._v(" "),(_vm.hasFieldVisibleError(_vm.field))?_c('template',{slot:"after"},[_c('IconCross',{staticStyle:{"width":"20px"}})],1):_c('template',{slot:"after"},[_c('IconDone',{staticStyle:{"width":"20px"}})],1)],2),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e()],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'multi-zipcode')?_vm._t("multi-zipcode",[_c('FieldMultiZipcode',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"value":_vm.model[_vm.field.model]},on:{"valueChange":function (value) { return _vm.$emit('valueChange', { field: _vm.field, value: value }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }}},'FieldMultiZipcode',_vm.getProps(_vm.field),false),[_c('span',{attrs:{"slot":"label"},domProps:{"innerHTML":_vm._s(_vm.field.label)},slot:"label"}),_vm._v(" "),(_vm.hasFieldVisibleError(_vm.field))?_c('template',{slot:"after"},[_c('IconCross',{staticStyle:{"width":"20px"}})],1):_c('template',{slot:"after"},[_c('IconDone',{staticStyle:{"width":"20px"}})],1)],2),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e()],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'phone-number')?_vm._t("phone-number",[_c('ClientOnly',[_c('BasePhoneNumber',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"value":_vm.model[_vm.field.model],"options":_vm.field.componentOptions},on:{"valueChange":function (typedValue, phoneNumber) { return _vm.$emit('phoneNumberValueChange', { field: _vm.field, typedValue: typedValue, phoneNumber: phoneNumber }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }}},'BasePhoneNumber',_vm.getProps(_vm.field),false),[_c('span',{attrs:{"slot":"label"},domProps:{"innerHTML":_vm._s(_vm.field.label)},slot:"label"}),_vm._v(" "),(_vm.hasFieldVisibleError(_vm.field))?_c('template',{slot:"after"},[_c('IconCross',{staticStyle:{"width":"20px"}})],1):_c('template',{slot:"after"},[_c('IconDone',{staticStyle:{"width":"20px"}})],1)],2),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e()],1)],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'progress-bar')?_vm._t("progress-bar",[_c('BaseProgressBar',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"value":_vm.model[_vm.field.model],"currentStep":_vm.field.currentStep,"totalSteps":_vm.field.totalSteps,"titles":_vm.field.progressBarStepTitles},on:{"valueChange":function (value) { return _vm.$emit('valueChange', { field: _vm.field, value: value }); }}},'BaseProgressBar',_vm.getProps(_vm.field),false))],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'upload')?_vm._t("upload",[_c('BaseFileUpload',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"value":_vm.model[_vm.field.model]},on:{"valueChange":function (value) { return _vm.$emit('valueChange', { field: _vm.field, value: value }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }}},'BaseFileUpload',_vm.getProps(_vm.field),false),[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n                "+_vm._s(_vm.field.label)+"\n            ")])]),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e()],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'multi-select')?_vm._t("multi-select",[_c('BaseMultiSelect',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"multiple":_vm.field.multiple,"closeOnSelect":!_vm.field.multiple,"label":_vm.field.choiceLabel,"track-by":_vm.field.choiceTrackBy,"value":_vm.model[_vm.field.model],"options":_vm.field.choices},on:{"valueChange":function (value) { return _vm.$emit('valueChange', { field: _vm.field, value: value }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }}},'BaseMultiSelect',_vm.getMultiSelectProps(_vm.field),false),[_c('span',{attrs:{"slot":"label"},domProps:{"innerHTML":_vm._s(_vm.field.label)},slot:"label"}),_vm._v(" "),(_vm.hasFieldVisibleError(_vm.field))?_c('template',{slot:"after"},[_c('IconCross',{staticStyle:{"margin-left":"10px","width":"20px"}})],1):_c('template',{slot:"after"},[_c('IconDone',{staticStyle:{"margin-left":"10px","width":"20px"}})],1)],2),_vm._v(" "),(_vm.field.hint && _vm.field.hint.length)?_c('div',{staticClass:"hint-text",domProps:{"innerHTML":_vm._s(_vm.field.hint)}}):_vm._e()],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'checklist-raw')?_vm._t("checklist-raw",[_c('FieldChecklist',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"field":_vm.field,"value":_vm.model[_vm.field.model]},on:{"valueChange":function (value) { return _vm.$emit('valueChange', { field: _vm.field, value: value }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }}})],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'select-raw')?_vm._t("select-raw",[_c('FieldSelect',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"field":_vm.field,"value":_vm.model[_vm.field.model]},on:{"valueChange":function (value) { return _vm.$emit('valueChange', { field: _vm.field, value: value }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }}})],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'checkbox-raw')?_vm._t("checkbox-raw",[_c('FieldCheckbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"field":_vm.field,"value":_vm.model[_vm.field.model]},on:{"valueChange":function (value) { return _vm.$emit('valueChange', { field: _vm.field, value: value }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }}})],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'radio-raw')?_vm._t("radio-raw",[_c('FieldRadio',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"value":_vm.model[_vm.field.model],"field":_vm.field},on:{"valueChange":function (value) { return _vm.$emit('valueChange', { field: _vm.field, value: value }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }}})],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'input-raw')?_vm._t("input-raw",[_c('FieldInput',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"value":_vm.model[_vm.field.model],"field":_vm.field},on:{"valueChange":function (value) { return _vm.$emit('valueChange', { field: _vm.field, value: value }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }}})],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'textarea-raw')?_vm._t("textarea-raw",[_c('FieldTextarea',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"value":_vm.model[_vm.field.model],"field":_vm.field},on:{"valueChange":function (value) { return _vm.$emit('valueChange', { field: _vm.field, value: value }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }}})],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'numeric-input-raw')?_vm._t("numeric-input-raw",[_c('FieldNumericInput',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"value":_vm.model[_vm.field.model],"field":_vm.field},on:{"valueChange":function (value) { return _vm.$emit('valueChange', { field: _vm.field, value: value }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }}})],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'zipcode-raw')?_vm._t("zipcode-raw",[_c('FieldZipcode',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"value":_vm.model[_vm.field.model],"field":_vm.field},on:{"valueChange":function (value) { return _vm.$emit('valueChange', { field: _vm.field, value: value }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }}})],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'upload-raw')?_vm._t("upload-raw",[_c('FieldUpload',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"value":_vm.model[_vm.field.model],"field":_vm.field},on:{"valueChange":function (value) { return _vm.$emit('valueChange', { field: _vm.field, value: value }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }}})],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'google-address-raw')?_vm._t("google-address-raw",[_c('FieldGoogleAddress',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"value":_vm.model[_vm.field.model],"field":_vm.field},on:{"valueChange":function (value) { return _vm.$emit('valueChange', { field: _vm.field, value: value }); },"focus":function ($event) { return _vm.$emit('fieldFocus', { $event: $event, field: _vm.field }); },"blur":function ($event) { return _vm.$emit('fieldBlur', { $event: $event, field: _vm.field }); }}})],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'progress-bar-raw')?_vm._t("progress-bar-raw",[_c('FieldProgressBar',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],attrs:{"value":_vm.model[_vm.field.model],"field":_vm.field},on:{"valueChange":function (value) { return _vm.$emit('valueChange', { field: _vm.field, value: value }); }}})],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'html')?_vm._t("html",[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}]},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.field.value)}})])],{"value":_vm.model[_vm.field.model],"field":_vm.field}):(_vm.field.type === 'link')?_vm._t("link",[_c('div',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.isFieldVisible(_vm.field)),expression:"isFieldVisible(field)"}],class:undefined,attrs:{"tabindex":"0"},domProps:{"innerHTML":_vm._s(_vm.field.value)},on:{"click":function($event){return _vm.field.listeners.click($event, _vm.field, _vm.model)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();$event.stopPropagation();return _vm.field.listeners.click($event, _vm.field, _vm.model)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();$event.stopPropagation();return _vm.field.listeners.click($event, _vm.field, _vm.model)}]}},'div',_vm.getProps(_vm.field),false))],{"value":_vm.model[_vm.field.model],"field":_vm.field}):_vm._t(_vm.field.type,[_c('div',[_vm._v("No component for field.type='"+_vm._s(_vm.field.type)+"' exists.")])],{"value":_vm.model[_vm.field.model],"field":_vm.field}),_vm._v(" "),(_vm.hasFieldVisibleError(_vm.field))?_vm._t("errors",[_c('div',{staticClass:"errors",attrs:{"role":"alert"}},_vm._l((_vm.errors[_vm.field.model]),function(error){return _c('span',{key:error},[_vm._v(" "+_vm._s(error)+" ")])}),0)],{"errors":_vm.errors,"field":_vm.field}):_vm._e()],2)};
var __vue_staticRenderFns__$c = [];

  /* style */
  var __vue_inject_styles__$c = undefined;
  /* scoped */
  var __vue_scope_id__$c = undefined;
  /* module identifier */
  var __vue_module_identifier__$c = undefined;
  /* functional template */
  var __vue_is_functional_template__$c = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$c = normalizeComponent(
    { render: __vue_render__$c, staticRenderFns: __vue_staticRenderFns__$c },
    __vue_inject_styles__$c,
    __vue_script__$c,
    __vue_scope_id__$c,
    __vue_is_functional_template__$c,
    __vue_module_identifier__$c,
    false,
    undefined,
    undefined,
    undefined
  );

function groupBy(list, keyGetter) {
    var map = new Map();
    list.forEach(function (item) {
         var key = keyGetter(item);
         var collection = map.get(key);
         if (!collection) {
             map.set(key, [item]);
         } else {
             collection.push(item);
         }
    });
    return  Object.fromEntries(map)
}

var script$d = {
    name: 'FormGenerator',

    components: {
        Fields: __vue_component__$c
    },

    props: {
        schema: {
            type: Object,
            required: true,
            validator: function(schema) {
                if (!schema || !schema.fields || !schema.fields.length) {
                    console.error("FormGenerator: 'schema.fields' must be a non empty array");
                    return false
                }

                var hasError = false;

                schema.fields.forEach(function (field) {
                    if (!field.type || !field.type.length) {
                        console.error("FormGenerator: 'schema.fields[].type' must be a non empty string");
                        hasError = true;
                    }
                    if (!field.model || !field.model.length) {
                        console.error("FormGenerator: 'schema.fields[].model' must be a non empty string");
                        hasError = true;
                    }
                });

                return !hasError
            },
        },

        model: {
            type: Object,
            default: function () {
                return {}
            },
        },

        errors: {
            type: Object,
            default: function () {
                return {}
            },
        },

        visibleErrors: {
            type: Object
        }
    },

    watch: {
        model: {
            handler: function() {
                var errors = this.validate(this.schema.fields);
                this.$emit('errorsChange', { errors: errors });
            },
            immediate: true,
            deep: true,
        },
    },

    computed: {
        groups: function groups() {
            return groupBy(this.schema.fields, function (field) {
                return field.group || 'main'
            })
        },

        fields: function fields() {
            var fields = this.groupFields([].concat( this.groups.main ), this.groups);
            return fields
        }
    },

    methods: {
        groupFields: function groupFields(fields, groups) {
            var this$1 = this;

            var groupedFields = fields.map(function (field) {
                if (field.type === 'group') {
                    return Object.assign({}, field, {
                        groupFields: this$1.groupFields(groups[field.model], groups)
                    })
                }

                return field
            });

            return groupedFields
        },
        // async validate(fields) {
        //     const allErrors = {}

        //     await Promise.all(fields.map(async (field) => {
        //         if (!field.validators || !field.validators.length || !this.isFieldVisible(field)) {
        //             return
        //         }

        //         return Promise.all(field.validators.map(async (validator) => {
        //             const errors = await validator(field, this.model)
        //             if (errors && errors.length) {
        //                 allErrors[field.model] = (allErrors[field.model] || []).concat(errors)
        //             }
        //         }))

        //     }))

        //     return allErrors
        // },

        validate: function validate(fields) {
            var this$1 = this;

            var allErrors = {};

            fields.forEach(function (field) {
                if (!field.validators || !field.validators.length || !this$1.isFieldVisible(field)) {
                    return
                }

                field.validators.forEach(function (validator) {
                    var errors = validator(field, this$1.model);
                    if (errors && errors.length) {
                        allErrors[field.model] = (allErrors[field.model] || []).concat(errors);
                    }
                });
            });

            return allErrors
        },

        handleChecklistValueChange: function handleChecklistValueChange(field, $event) {
            var value = $event.currentTarget.value;
            var values = Object.assign([], this.model[field.model]);

            var index = values.indexOf(value);
            if (index >= 0) {
                values.splice(index, 1);
            } else {
                values.push(value);
            }
            this.$emit('fieldChange', { field: field, value: values });
        },

        handleTaglistValueChange: function handleTaglistValueChange(field, value) {
            if (field.referenceTo) {
                var referenceField = this.schema.fields.find(function (ref) {
                    var model = ref.model;

                    return model === field.referenceTo;
                });
                var values = Object.assign([], this.model[field.referenceTo]);

                var index = values.indexOf(value);
                if (index >= 0) {
                    values.splice(index, 1);
                }

                this.$emit('fieldChange', { field: referenceField, value: values });
            } else {
                var values$1 = Object.assign([], this.model[field.model]);

                var index$1 = values$1.indexOf(value);
                if (index$1 >= 0) {
                    values$1.splice(index$1, 1);
                }
                this.$emit('fieldChange', { field: field, value: values$1 });
            }
        },

        handleNumericInputValueChange: function handleNumericInputValueChange(field, $event) {
            var value = $event.target.value.replace(/[^\d]/g, '');

            if (value === this.model[field.model]) {
                $event.target.value = value;
            } else {
                this.$emit('fieldChange', { field: field, value: value });
            }
        },

        handleDateInputValueChange: function handleDateInputValueChange(field, $event) {
            var insertAt = function (str, sub, pos) { return ("" + (str.slice(0, pos)) + sub + (str.slice(pos))); };

            var value = $event.target.value;
            var position = $event.target.selectionStart;

            if ($event.inputType === 'deleteContentBackward') {
                this.$emit('fieldChange', { field: field, value: value });
                return
            }

            if (position === value.length) {
                value = value.replace(/[^\d]/g, '');
                if (value.charAt(2) !== '/' && value.length >= 2) {
                    value = insertAt(value, '/', 2);
                }

                if (value.charAt(5) !== '/' && value.length >= 5) {
                    value = insertAt(value, '/', 5);
                }
            }
            // else {
            //     if (value.charAt(2) !== '/' && position === 2) {
            //         console.log('debug: insert at 2')
            //         value = insertAt(value, '/', 2)
            //     }

            //     if (value.charAt(5) !== '/' && position === 5) {
            //         console.log('debug: insert at 5')
            //         value = insertAt(value, '/', 5)
            //     }
            // }

            this.$emit('fieldChange', { field: field, value: value });
        },

        handlePhoneNumberValueChange: function handlePhoneNumberValueChange(field, typedValue, phoneNumber) {
            if(!typedValue || !typedValue.length) {
                return
            }
            this.$emit('fieldChange', { field: field, value: phoneNumber });
        },

        handleValueChange: function handleValueChange(field, value) {
            this.$emit('fieldChange', { field: field, value: value });
        },

        getProps: function getProps(field) {
            var value = this.model[field.model];
            var hasValue;
            if (Array.isArray(value)) {
                hasValue = value.length;
            } else {
                hasValue = !!value;
            }
            var hasErrors = this.hasFieldVisibleError(field);
            var classname = (field.classname || '') + " " + (hasErrors ? 'has-errors' : '') + " " + (hasValue && !hasErrors ? 'is-success' : '');
            return Object.assign({}, field, {
                type: field.inputType,
                class: classname,
                classname: undefined,
                label: undefined,
                validators: undefined,
                visible: undefined,
                choices: undefined,
                model: undefined,
                group: undefined,
                groupFields: undefined,
            })
        },

        getMultiSelectProps: function getMultiSelectProps(field) {
            return Object.assign({}, this.getProps(field), field.componentOptions)
        },

        getTaglistProps: function getTaglistProps(field) {
            return Object.assign({}, this.getProps(field), field.componentOptions)
        },

        isFieldVisible: function isFieldVisible(field) {
            if (field.visible === undefined) {
                return true
            } else if (typeof field.visible === 'function') {
                return !(field.visible(this.model) === false)
            } else {
                return field.visible
            }
        },

        hasFieldVisibleError: function hasFieldVisibleError(field) {
          return this.errors[field.model] && this.visibleErrors && this.visibleErrors[field.model]
        },

        hasFieldError: function hasFieldError(field) {
          return this.errors[field.model]
        }
    },
};

/* script */
var __vue_script__$d = script$d;

/* template */
var __vue_render__$d = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"form-generator"},[_vm._l((_vm.fields),function(field,i){return _c('Fields',{key:i + '_' + field.type,attrs:{"field":field,"model":_vm.model,"errors":_vm.errors,"hasFieldVisibleError":_vm.hasFieldVisibleError,"hasFieldError":_vm.hasFieldError,"isFieldVisible":_vm.isFieldVisible,"getProps":_vm.getProps,"getMultiSelectProps":_vm.getMultiSelectProps,"getTaglistProps":_vm.getTaglistProps},on:{"dateInputValueChange":function (ref) {
	var $event = ref.$event;
	var field = ref.field;

	return _vm.handleDateInputValueChange(field, $event);
},"phoneNumberValueChange":function (ref) {
	var field = ref.field;
	var typedValue = ref.typedValue;
	var phoneNumber = ref.phoneNumber;

	return _vm.handlePhoneNumberValueChange(field, typedValue, phoneNumber);
},"numericInputValueChange":function (ref) {
	var $event = ref.$event;
	var field = ref.field;

	return _vm.handleNumericInputValueChange(field, $event);
},"checklistValueChange":function (ref) {
	var $event = ref.$event;
	var field = ref.field;

	return _vm.handleChecklistValueChange(field, $event);
},"taglistValueChange":function (ref) {
	var value = ref.value;
	var field = ref.field;

	return _vm.handleTaglistValueChange(field, value);
},"valueChange":function (ref) {
	var field = ref.field;
	var value = ref.value;

	return _vm.handleValueChange(field, value);
},"fieldFocus":function ($event) { return _vm.$emit('fieldFocus', $event); },"fieldBlur":function ($event) { return _vm.$emit('fieldBlur', $event); }},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}})],null,true)})}),_vm._v(" "),_vm._t("after")],2)};
var __vue_staticRenderFns__$d = [];

  /* style */
  var __vue_inject_styles__$d = undefined;
  /* scoped */
  var __vue_scope_id__$d = undefined;
  /* module identifier */
  var __vue_module_identifier__$d = undefined;
  /* functional template */
  var __vue_is_functional_template__$d = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$d = normalizeComponent(
    { render: __vue_render__$d, staticRenderFns: __vue_staticRenderFns__$d },
    __vue_inject_styles__$d,
    __vue_script__$d,
    __vue_scope_id__$d,
    __vue_is_functional_template__$d,
    __vue_module_identifier__$d,
    false,
    undefined,
    undefined,
    undefined
  );

var stepsMixin = {
    data: function data() {
        return {
            stepDirection: 'next',
        }
    },

    computed: {
        currentStep: function currentStep() {
            return this.steps[this.currentStepSlug]
        },

        currentStepSlug: function currentStepSlug() {
            return this.$route.params.stepSlug
        },

        continueTo: function continueTo() {
            if (!this.currentStep) {
                return undefined
            }
            return this.currentStep.continueTo(this.currentStep.model, this.currentStep.schema.fields)
        },
    },

    methods: {
        handlePrevClick: function handlePrevClick() {
            this.stepDirection = 'prev';
            this.$router.go(-1);
        },

        handleNextClick: function handleNextClick() {
            this.stepDirection = 'next';
            this.$router.push(Object.assign({}, this.$route, {
                params: {
                    stepSlug: this.continueTo
                }
            }));
        },
    },
};

// validators adapted from https://github.com/vue-generators/vue-form-generator/blob/master/src/utils/validators.js

var isNil = function (value) { return value === undefined || value === null; };
var isNumber = function (value) { return !isNaN(parseFloat(value)) && isFinite(value); };
var isInteger = function (value) { return Number.isInteger(value); };
var isString = function (value) { return typeof value === 'string' || value instanceof String; };
var isArray = function (value) { return Array.isArray(value); };

var defaultMessages = {
    fieldIsRequired: 'Ce champ est obligatoire.',
    dateIsRequired: 'Le champ date est obligatoire.',
    timeIsRequired: 'Le champ heure est obligatoire.',
    invalidFormat: 'Ce format est incorrect.',

    numberTooSmall: 'Nombre incorrect. Il doit être supérieur à {0}.',
    numberTooBig: 'Nombre incorrect. Il doit être inférieur à {0}.',
    invalidNumber: 'Ce nombre est incorrect.',
    invalidInteger: 'La valeur doit être un nombre entier.',

    textTooSmall: 'Votre texte est trop court. Merci de compléter. En cours : {0}, minimum : {1}.',
    textTooBig: 'Votre texte est trop long. En cours : {0}, maximum : {1}.',
    thisNotText: 'Ce n’est pas un texte.',

    thisNotArray: 'Ce n’est pas un tableau.',

    selectMinItems: 'Sélectionner au minimum {0} choix.',
    selectMaxItems: 'Sélectionner au maximum {0} choix.',

    invalidDate: 'Date invalide.',
    dateIsEarly: 'Cette date est trop tôt.',
    dateIsLate: 'Cette date est trop tard.',
    dateIsSunday: 'Nos agences sont fermées le dimanche, merci de choisir un autre jour du lundi au samedi.',

    invalidEmail: 'Adresse e-mail incorrecte.',
    invalidPhone: "Le format du numéro de téléphone n'est pas valide.",
    invalidURL: 'Adresse url incorrecte.',

    invalidCard: 'Format de carte bancaire incorrect.',
    invalidCardNumber: 'Numéro de carte incorrect.',

    invalidAddress: 'Adresse incorrecte.',

    invalidTextContainNumber: 'Champ incorrect. Il ne doit pas contenir de chiffres ni de caractères spéciaux.',
    invalidTextContainSpec: 'Champ incorrect. Il ne doit pas contenir de caractères spéciaux.',

    mustBeChecked: 'Vous devez accepter ce champ avant de valider le formulaire.',

    fileTooBig: 'Votre document dépasse le poids autorisé. Merci de réduire la taille de votre fichier.',
    fileInvalidExtension: 'Votre document n\'est pas dans un format autorisé. Nous conseillons de télécharger un fichier PDF.',
};

function checkEmpty(value, required, messages) {
    if ( messages === void 0 ) messages = defaultMessages;

    if (isNil(value) || value === '') {
        if (required) {
            return [msg(messages.fieldIsRequired)]
        } else {
            return []
        }
    }
    return null
}

function msg(text) {
    var arguments$1 = arguments;

    if (text != null && arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            text = text.replace('{' + (i - 1) + '}', arguments$1[i]);
        }
    }

    return text
}

var validators = {
    required: function required(field, model, messages) {
        if ( messages === void 0 ) messages = defaultMessages;

        if (!model[field.model] || model[field.model].length < 1) {
            return [msg(messages.fieldIsRequired)]
        }
    },

    checked: function checked(field, model, messages) {
        if ( messages === void 0 ) messages = defaultMessages;

        if (!model[field.model]) {
            return [msg(messages.mustBeChecked)]
        }
    },

    number: function number(field, model, messages) {
        if ( messages === void 0 ) messages = defaultMessages;

        var value = parseInt(model[field.model]);
        var err = [];
        if (isFinite(value)) {
            if (!isNil(field.min) && value < parseInt(field.min)) {
                err.push(msg(messages.numberTooSmall, field.min));
            }

            if (!isNil(field.max) && value > parseInt(field.max)) {
                err.push(msg(messages.numberTooBig, field.max));
            }
        } else {
            err.push(msg(messages.invalidNumber));
        }

        return err
    },

    integer: function integer(field, model, messages) {
        if ( messages === void 0 ) messages = defaultMessages;

        var value = model[field.model];
        var errs = validators.number(value, field, model, messages);

        if (!isInteger(value)) {
            errs.push(msg(messages.invalidInteger));
        }

        return errs
    },

    double: function double(field, model, messages) {
        if ( messages === void 0 ) messages = defaultMessages;

        var value = model[field.model];
        if (!isNumber(value) || isNaN(value)) {
            return [msg(messages.invalidNumber)]
        }
    },

    string: function string(field, model, messages) {
        if ( messages === void 0 ) messages = defaultMessages;

        var value = model[field.model];
        var err = [];
        if (isString(value)) {
            if (!isNil(field.min) && value.length < field.min) {
                err.push(msg(messages.textTooSmall, value.length, field.min));
            }

            if (!isNil(field.max) && value.length > field.max) {
                err.push(msg(messages.textTooBig, value.length, field.max));
            }
        } else {
            err.push(msg(messages.thisNotText));
        }

        return err
    },

    dateTime: function dateTime(field, model, messages) {
        if ( messages === void 0 ) messages = defaultMessages;

        var value = model[field.model];
        var err = [];

        if (!value) {
            err.push(msg(messages.fieldIsRequired));
        } else if (!value.date) {
            err.push(msg(messages.dateIsRequired));
        }  else if (!value.time) {
            err.push(msg(messages.timeIsRequired));
        }

        return err
    },

    array: function array(field, model, messages) {
        if ( messages === void 0 ) messages = defaultMessages;

        var value = model[field.model];
        if (field.required) {
            if (!isArray(value)) {
                return [msg(messages.thisNotArray)]
            }

            if (value.length === 0) {
                return [msg(messages.fieldIsRequired)]
            }
        }

        if (!isNil(value)) {
            if (!isNil(field.min) && value.length < field.min) {
                return [msg(messages.selectMinItems, field.min)]
            }

            if (!isNil(field.max) && value.length > field.max) {
                return [msg(messages.selectMaxItems, field.max)]
            }
        }
    },

    regexp: function regexp(field, model, messages) {
        if ( messages === void 0 ) messages = defaultMessages;

        var value = model[field.model];
        var res = checkEmpty(value, field.required, messages);
        if (res != null) { return res }

        if (!isNil(field.pattern)) {
            var re = new RegExp(field.pattern);

            // Ignore accents
            if (!re.test(value.normalize("NFD").replace(/[\u0300-\u036f]/g, ""))) {
                return [msg(messages.invalidFormat)]
            }
        }
    },

    email: function email(field, model, messages) {
        if ( messages === void 0 ) messages = defaultMessages;

        var value = model[field.model];
        var res = checkEmpty(value, field.required, messages);
        if (res != null) { return res }

        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
        if (!re.test(value)) {
            return [msg(messages.invalidEmail)]
        }

        var unallowedChars = ["%", ";", ",", "?", "!", ":", "[", "]", ")", "(", "{", "}", "=", "°", "~", "\"", "/", "#", "^", "|", "`", "*", "$", "£", "¤", ")"];
        if (unallowedChars.some(function (v) { return value.includes(v); })) {
            return [msg(messages.invalidEmail)]
        }
    },

    date: function date(field, model, messages) {
        if ( messages === void 0 ) messages = defaultMessages;

        var value = model[field.model];

        var res = checkEmpty(value, field.required, messages);
        if (res != null) { return res }

        if (!value.match(/\d{2}\/\d{2}\/\d{4}/)) {
            return [msg(messages.invalidDate)]
        }
        var err = [];

        var fragments = value.split('/');
        var year = fragments[2];
        var month = fragments[1];
        var day = fragments[0];

        if (parseInt(month) > 12) {
            return [msg(messages.invalidDate)]
        }
        if (parseInt(day) > 31) {
            return [msg(messages.invalidDate)]
        }

        var valueDate = new Date((year + "-" + month + "-" + day));
        var minDate = new Date(field.min);
        var maxDate = new Date(field.max);

        if (!isNil(field.min) && valueDate < minDate) {
            err.push(msg(messages.dateIsEarly, field.min));
        }

        if (!isNil(field.max) && valueDate > maxDate) {
            err.push(msg(messages.dateIsLate, field.max));
        }

        return err
    },

    notSundays: function notSundays(field, model, messages) {
        if ( messages === void 0 ) messages = defaultMessages;

        var value = model[field.model];
        if (!value) { return }

        var err = [];

        var fragments = value.split('/');
        var year = fragments[2];
        var month = fragments[1];
        var day = fragments[0];

        var valueDate = new Date((year + "-" + month + "-" + day));

        if (valueDate.getDay() === 0) {
            err.push(msg(messages.dateIsSunday));
        }

        return err
    },

    phone: function phone(field, model, messages) {
        if ( messages === void 0 ) messages = defaultMessages;

        var value = model[field.model];
        var res = checkEmpty(value, field.required, messages);
        if (res != null) { return res }

        if (value.length < 10 || !/^\d+$/.test(value)) {
            return [msg(messages.invalidPhone)]
        }
    },

    validPhoneNumber: function validPhoneNumber(field, model, messages) {
        if ( messages === void 0 ) messages = defaultMessages;

        var forbiddenPhoneNumbers = [
            '06 00 00 00 00',
            '07 00 00 00 00',
            '01 01 01 01 01',
            '01 02 03 04 05',
            '01 23 45 67 89',
            '06 01 02 03 04',
            '11 22 33 44 55',
            '00 00 00 00 00',
            '01 11 11 11 11',
            '02 22 22 22 22',
            '03 33 33 33 33',
            '04 44 44 44 44',
            '05 55 55 55 55',
            '06 66 66 66 66',
            '07 77 77 77 77',
            '09 99 99 99 99' ];

        var value = model[field.model];
        var res = checkEmpty(value, field.required, messages);
        if (res != null) { return res }

        if (value.valid !== true) {
            return [msg(messages.invalidPhone)]
        }

        if (forbiddenPhoneNumbers.includes(value.nationalNumber)) {
            return [msg(messages.invalidPhone)]
        }
    },

    url: function url(field, model, messages) {
        if ( messages === void 0 ) messages = defaultMessages;

        var value = model[field.model];
        var res = checkEmpty(value, field.required, messages);
        if (res != null) { return res }

        var re = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g; // eslint-disable-line no-useless-escape
        if (!re.test(value)) {
            return [msg(messages.invalidURL)]
        }
    },

    creditCard: function creditCard(field, model, messages) {
        if ( messages === void 0 ) messages = defaultMessages;

        var value = model[field.model];
        var res = checkEmpty(value, field.required, messages);
        if (res != null) { return res }

        /*  From validator.js code
            https://github.com/chriso/validator.js/blob/master/src/lib/isCreditCard.js
        */
        var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/;
        var sanitized = value.replace(/[^0-9]+/g, '');
        if (!creditCard.test(sanitized)) {
            return [msg(messages.invalidCard)]
        }
        var sum = 0;
        var digit;
        var tmpNum;
        var shouldDouble;
        for (var i = sanitized.length - 1; i >= 0; i--) {
            digit = sanitized.substring(i, i + 1);
            tmpNum = parseInt(digit, 10);
            if (shouldDouble) {
                tmpNum *= 2;
                if (tmpNum >= 10) {
                    sum += (tmpNum % 10) + 1;
                } else {
                    sum += tmpNum;
                }
            } else {
                sum += tmpNum;
            }
            shouldDouble = !shouldDouble;
        }

        if (!(sum % 10 === 0 ? sanitized : false)) {
            return [msg(messages.invalidCardNumber)]
        }
    },

    alpha: function alpha(field, model, messages) {
        if ( messages === void 0 ) messages = defaultMessages;

        var value = model[field.model];
        var res = checkEmpty(value, field.required, messages);
        if (res != null) { return res }

        var re = /^[a-zA-Z]*$/;
        if (!re.test(value)) {
            return [msg(messages.invalidTextContainNumber)]
        }
    },

    alphaNumeric: function alphaNumeric(field, model, messages) {
        if ( messages === void 0 ) messages = defaultMessages;

        var value = model[field.model];
        var res = checkEmpty(value, field.required, messages);
        if (res != null) { return res }

        var re = /^[a-zA-Z0-9]*$/;
        if (!re.test(value)) {
            return [msg(messages.invalidTextContainSpec)]
        }
    },

    name: function name(field, model, messages) {
        if ( messages === void 0 ) messages = defaultMessages;

        var value = model[field.model];
        var res = checkEmpty(value, field.required, messages);
        if (res != null) { return res }

        var re = /^[a-zA-Z-' ]*$/;
        // Ignore accents
        if (!re.test(value.normalize("NFD").replace(/[\u0300-\u036f]/g, ""))) {
            return [msg(messages.invalidTextContainSpec)]
        }
    },

    googleAddress: function googleAddress(field, model, messages) {
        if ( messages === void 0 ) messages = defaultMessages;

        var value = model[field.model];
        var res = checkEmpty(value, field.required, messages);
        if (res != null) { return res }
        if (typeof value !== 'object') {
            return [msg(messages.invalidAddress)]
        }
    },

    fileSize: function fileSize(field, model, messages) {
        if ( messages === void 0 ) messages = defaultMessages;

        var value = model[field.model];
        if (!value) { return }
        var tooBig = value.some(function (file) {
            return file.file.size / 1024 / 1024 > parseInt(field.maxFileSize)
        });

        if (tooBig) {
            return [msg(messages.fileTooBig, field.maxFileSize)]
        }
    },

    fileExtension: function fileExtension(field, model, messages) {
        if ( messages === void 0 ) messages = defaultMessages;

        var value = model[field.model];
        if (!value) { return }
        if (!field.accept || !field.accept.length) { return }

        var invalidExtension = value.some(function (file) {
            var extension = file.file.name.split('.').pop();
            return !field.accept.includes('.' + extension)
        });

        if (invalidExtension) {
            return [msg(messages.fileInvalidExtension, field.accept)]
        }
    },
};

Object.keys(validators).forEach(function (name) {
    var validator = validators[name];
    validator.withMessages = function (customMessages) { return function (field, model) { return validator(field, model, Object.assign({}, defaultMessages, customMessages)); }; };
});

// Import vue component

// Declare install function executed by Vue.use()
function install(Vue) {
	if (install.installed) { return }
	install.installed = true;
	Vue.component('FormGenerator', __vue_component__$d);
}

// Create module definition for Vue.use()
var plugin = {
	install: install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
var GlobalVue = null;
if (typeof window !== 'undefined') {
	GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
	GlobalVue = global.Vue;
}
if (GlobalVue) {
	GlobalVue.use(plugin);
}

export { __vue_component__$d as FormGenerator, validators as fieldValidators, install, stepsMixin };
